import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "p-2 bg-white dark:border-gray-800 rounded-md shadow-md mt-4" }
const _hoisted_2 = ["src"]
const _hoisted_3 = ["src", "onClick"]
const _hoisted_4 = { key: 1 }

import { computed, ref, watch } from 'vue';
  import { Swiper, SwiperSlide } from 'swiper/vue';
  import 'swiper/swiper-bundle.css';
  import { Navigation, Autoplay, Pagination } from 'swiper/modules';
  import moment from 'moment/moment';
  import { formatMoney } from '@/helpers/helper';

  interface Image {
    thumbnailUrl: string;
    fullUrl: string;
  }

  
export default /*@__PURE__*/_defineComponent({
  __name: 'SliderWithModal',
  props: {
    images: {}
  },
  setup(__props: any) {

  const props = __props;

  const showModal = ref(false);
  const currentImageIndex = ref<number>(0);
  const isAutoplayEnabled = ref(true); // Автопрокрутка включена
  const rotationAngle = ref(0); // Угол поворота изображения

  // Текущее изображение в большом блоке
  const currentMainImage = computed(() =>
    props.images.length > 0 && currentImageIndex.value >= 0
      ? props.images[currentImageIndex.value]?.fullUrl || null
      : null
  );

  const currentImage = computed(() =>
    props.images.length > 0 &&
    currentImageIndex.value >= 0 &&
    currentImageIndex.value < props.images.length
      ? props.images[currentImageIndex.value]?.fullUrl || null
      : null
  );

  const openModal = (index: number): void => {
    if (index >= 0 && index < props.images.length) {
      currentImageIndex.value = index;
      showModal.value = true;
      isAutoplayEnabled.value = false; // Отключаем автопрокрутку
      document.body.classList.add('no-scroll'); // Блокируем прокрутку
    }
  };

  const closeModal = (): void => {
    showModal.value = false;
    rotationAngle.value = 0; // Сбрасываем угол поворота
    isAutoplayEnabled.value = true; // Включаем автопрокрутку
    document.body.classList.remove('no-scroll'); // Включаем прокрутку
  };

  const prevImage = (): void => {
    if (props.images.length > 0) {
      currentImageIndex.value =
        (currentImageIndex.value - 1 + props.images.length) %
        props.images.length;
      rotationAngle.value = 0; // Сбрасываем угол поворота при смене изображения
    }
  };

  const nextImage = (): void => {
    if (props.images.length > 0) {
      currentImageIndex.value =
        (currentImageIndex.value + 1) % props.images.length;
      rotationAngle.value = 0; // Сбрасываем угол поворота при смене изображения
    }
  };

  const rotateImage = (): void => {
    rotationAngle.value = (rotationAngle.value + 90) % 360; // Вращение на 90 градусов
  };

  const updateMainImage = (swiper: any): void => {
    if (
      swiper?.realIndex !== undefined &&
      swiper.realIndex < props.images.length
    ) {
      currentImageIndex.value = swiper.realIndex;
    }
  };

  // Убедимся, что при уничтожении компонента скролл включается
  watch(showModal, (newVal) => {
    if (!newVal) {
      document.body.classList.remove('no-scroll');
    }
  });

return (_ctx: any,_cache: any) => {
  const _component_Image = _resolveComponent("Image")!
  const _component_Carousel = _resolveComponent("Carousel")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.images.length > 0)
      ? (_openBlock(), _createBlock(_component_Carousel, {
          key: 0,
          value: _ctx.images,
          numVisible: 1,
          numScroll: 1
        }, {
          item: _withCtx((itemProps) => [
            _createVNode(_component_Image, {
              alt: "Image",
              preview: ""
            }, {
              previewicon: _withCtx(() => _cache[0] || (_cache[0] = [
                _createElementVNode("i", { class: "pi pi-search" }, null, -1)
              ])),
              image: _withCtx(() => [
                _createElementVNode("img", {
                  src: itemProps.data.url,
                  alt: "image"
                }, null, 8, _hoisted_2)
              ]),
              preview: _withCtx((previewProps) => [
                _createElementVNode("img", {
                  src: itemProps.data.url,
                  alt: "preview",
                  style: _normalizeStyle(previewProps.style),
                  onClick: previewProps.onClick
                }, null, 12, _hoisted_3)
              ]),
              _: 2
            }, 1024)
          ]),
          _: 1
        }, 8, ["value"]))
      : (_openBlock(), _createElementBlock("div", _hoisted_4, "Haven't images"))
  ]))
}
}

})